'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = requireMembershipSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _selectors = require('redux/saga/selectors');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(requireMembershipSaga);

function requireMembershipSaga(client, replaceState, validStatuses) {
  var profile, status;
  return _regenerator2.default.wrap(function requireMembershipSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (!_context.sent) {
            _context.next = 11;
            break;
          }

          _context.next = 5;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 5:
          profile = _context.sent;
          status = profile.membership.status;

          if (!(validStatuses.indexOf(status) === -1)) {
            _context.next = 11;
            break;
          }

          _context.next = 10;
          return (0, _effects.call)(replaceState, '/');

        case 10:
          return _context.abrupt('return', _context.sent);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}